import { useData } from '../store';
const { init_data, login_status } = useData();
class DataReporter {
  constructor() {
    this.queue = []; // 任务队列
    this.isReporting = false; // 是否正在上报
    this.maxRetries = 3; // 最大重试次数
    this.timeout = 1000; // requestIdleCallback 超时时间
    this.maxImgUrlLength = 2048; // 图片打点 URL 最大长度限制
    this.DataReporterInit();
  }

  // 初始化
  DataReporterInit() {
    // 监听页面可见性变化，在页面隐藏时使用 Beacon API 上报
    this.loadQueueFromStorage();
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.flushQueueWithBeacon();
      }
    });

    // 监听页面卸载事件，使用 Beacon API 上报
    window.addEventListener('pagehide', () => {
      this.flushQueueWithBeacon();
    });
  }
  loadQueueFromStorage() {
    try {
      const saved = localStorage.getItem('analytics_queue');
      if (saved) {
        this.queue = JSON.parse(saved);
        localStorage.removeItem('analytics_queue');
      }
    } catch (_) {
      console.warn('恢复队列失败');
    }
  }

  // 添加数据到队列
  add(report_data) {
    const data = {};
    data['activity'] = import.meta.env.VITE_NAME;
    data['op_code'] = 'click_btn';
    data['details'] = report_data;
    data['server_group'] = import.meta.env.VITE_TEAM == 'tx2' ? 2 : 1;
    if (login_status.value) {
      data['account_id'] = init_data.account_data.username;
      data['role_name'] = '';
      data['role_id'] = '';
    } else {
      data['account_id'] = '';
      data['role_name'] = '';
      data['role_id'] = '';
    }
    data['h5user_id'] = window.figureCode;
    this.queue.push({ data, retries: 0 });
    this.scheduleReport();
  }

  // 调度上报任务
  scheduleReport() {
    if (this.isReporting || this.queue.length === 0) return;

    if (typeof requestIdleCallback === 'function') {
      // 优先使用 requestIdleCallback
      requestIdleCallback(() => this.report(), { timeout: this.timeout });
    } else {
      // 其次使用微任务
      Promise.resolve().then(() => this.report());
    }
  }

  // 执行上报
  async report() {
    if (this.isReporting || this.queue.length === 0) return;
    this.isReporting = true;
    const task = this.queue.shift();
    try {
      await this.sendData(task.data);
    } catch (_) {
      task.retries += 1;
      if (task.retries < this.maxRetries) {
        this.queue.push(task);
      }
    } finally {
      this.isReporting = false;
      this.scheduleReport();
    }
  }

  // 发送数据
  async sendData(data) {
    const url = `${import.meta.env.VITE_BASEAPI}/tx3/us/collect_log`;
    const dataStr = JSON.stringify(data);

    // 其次使用 Beacon API
    if (typeof navigator.sendBeacon === 'function') {
      return this.sendDataWithBeacon(url, dataStr);
    }

    // 最后使用 XHR
    return this.sendDataWithXHR(url, dataStr);
  }
  // 使用 Beacon API 上报
  sendDataWithBeacon(url, dataStr) {
    navigator.sendBeacon(url, dataStr);
  }

  // 使用 XHR 上报
  sendDataWithXHR(url, dataStr) {
    fetch(url, {
      method: 'POST',
      body: dataStr,
      mode: 'cors',
      keepalive: true,
    });
  }

  // 使用 Beacon API 上报队列中的数据
  flushQueueWithBeacon() {
    if (this.queue.length === 0) return;

    const url = `${import.meta.env.VITE_BASEAPI}/tx3/us/collect_log?batch=1`;

    // 限制上报数量，避免超限
    const MAX_SIZE = 50;
    const batch = this.queue.slice(0, MAX_SIZE);
    const taskData = batch.map((task) => task.data);
    const blob = new Blob([JSON.stringify({ logs: taskData })], {
      type: 'application/json',
    });
    if (navigator.sendBeacon(url, blob)) {
      console.log('✅ Beacon 上报成功，条数:', batch.length);
      // 仅移除已发送的部分
      this.queue = this.queue.slice(MAX_SIZE);

      // 如果还有剩余，可考虑延迟重试 or 等待下次 unload
      if (this.queue.length > 0) {
        console.log('🟡 仍有未发送数据，等待下次上报');
      }
    } else {
      console.error('❌ Beacon 上报失败，数据将保留重试');
      // 不清空队列，可选：存入 localStorage
      try {
        localStorage.setItem('analytics_queue', JSON.stringify(this.queue));
      } catch (_) {
        console.warn('localStorage 写入失败');
      }
    }
    this.isReporting = false;
  }
}
export default DataReporter;
